import { APP_CATALOG } from './catalog';

export interface AppLauncherConfig {
  /**
   * Map of catalog app id -> enabled. A missing key means "use catalog default"
   * (enabled). Only `false` hides an app.
   */
  enabled: Record<string, boolean>;
}

export const DEFAULT_APP_LAUNCHER_CONFIG: AppLauncherConfig = {
  enabled: Object.fromEntries(APP_CATALOG.map((app) => [app.id, true])),
};

/**
 * Coerce untrusted stored config into a valid `AppLauncherConfig`. Drops
 * unknown keys and non-boolean values; missing keys default to enabled.
 */
export function mergeAppLauncherConfig(partial: Partial<AppLauncherConfig> | null | undefined): AppLauncherConfig {
  const rawEnabled = partial?.enabled;
  const enabled: Record<string, boolean> = {};
  for (const app of APP_CATALOG) {
    const value = rawEnabled && typeof rawEnabled === 'object' ? (rawEnabled as Record<string, unknown>)[app.id] : undefined;
    enabled[app.id] = typeof value === 'boolean' ? value : true;
  }
  return { enabled };
}
